import { UserModel } from './UserModel';

export class LeaderboardUserModel extends UserModel {
    constructor(userData) {
        super(userData);

        this._leaderboardUser = {
            ...this._user,
            metric: userData.metric,
            workoutCreatedAt: userData.workout_created_at,
        };
    }

    get leaderboardUser() {
        return this._leaderboardUser;
    }
}



// WEBPACK FOOTER //
// ./src/BusinessLogic/Models/LeaderboardUserModel.js